<mat-sidenav-container *ngIf="isMobile">
  <mat-sidenav #sidenav mode="over">

    <!-- Este menu se autogenera, al igual que el antiguo menú que comentaste en la parte inferior. Se debe hacer uno de forma manual en el caso de que quieras seguirlo modificando de la misma forma que modificaste el anterior, o se puede seguir usando el autogenerado pero hay que cuidar que las rutas sean las mismas que en el creado de forma manual.-->
    <div>
      <img src="{{images.logo_epione}}" />
      <ng-container *ngFor="let navRoute of homeUiNavRoutes">

        <div *ngIf="!navRoute.hasChildren">
          <button  (click)="goToRoute(navRoute.navigationDataRoute.path)" mat-button>
            {{navRoute.navigationDataRoute.name}}
          </button>
        </div>

        <div *ngIf="navRoute.hasChildren">
          <button mat-button [matMenuTriggerFor]="menu">
            {{navRoute.navigationDataRoute.name}}
          </button>
          <mat-menu #menu="matMenu">
            <button (click)="goToSubRoute(navRoute.navigationDataRoute.path, child.path)" mat-menu-item *ngFor="let child of navRoute.navigationDataRoute.children">
              {{child.name}}
            </button>
          </mat-menu>
        </div>


      </ng-container>

      <div>

        <button mat-button (click)="goToDohealth()">
          Ir Dohealth
        </button>
      </div>

      <div>

        <button mat-button (click)="goToLogIn()">
          Iniciar Sesión <mat-icon color="accent">input</mat-icon>
        </button>
      </div>

    </div>
  </mat-sidenav>

  <mat-sidenav-content>

    <mat-toolbar id="mobileTopBar" *ngIf="isMobile">
      <mat-toolbar-row>

        <!--SE BLOQUEÓ EL BOTON DEL MENU DE MOBILE YA QUE EL MENU QUE REALIZASTE SUSTITUYE EL MENU GENERADO DE FORMA DINÁMICA Y SOLO LO HICISTE PARA LA VERSIÓIN DE ESCRITORIO-->
        <button mat-icon-button  (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <img src="{{images.logo_epione}}" />
      </mat-toolbar-row>
    </mat-toolbar>

    <div id="views-container">

      <router-outlet *ngIf="isMobile"></router-outlet>

    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-toolbar *ngIf="!isMobile" class="content-menu">
  <div class="content" class="content-menu1">
    <div class="centrarver">
      <img src="{{images.logo_epione}}" />
    </div>
    <div class="content">
      <ul class="fullnav">
        <li>
          <button mat-flat-button [disableRipple]="true" (click)="goToRoute('main')">
            Inicio
          </button>
        </li>
        <li class="somos">
          <button mat-flat-button [disableRipple]="true">
            Tecnología
          </button>
          <div class="sub">
            <div class="row">
              <div class="col-3">
                <h3>Tecnología</h3>
              </div>
              <div class="col-9">
                <div class="row sublinks">
                  <div class="col-6">
                    <!-- Si se pone el path de la ruta declarada en el JSON que recibe el navroutedata el contenedor de microfrontend tratará de buscar un componente con esa ruta específica y de existir lo colocará, de momento no funcionarán los componentes ya que se puso el Construction Component en todas las rutas del JSON, eso peude ser facilmente modificado en el POSTMAN con la API, las rutas se encuentran en EpioneGeneral en Organizations hay que buscar la organización con el nombre "Epione Home" y en la parte inferior en los datos de tools, ahí es donde estántodas las rutas de home..-->

                    <button mat-flat-button [disableRipple]="true" class="subtitulo" (click)="goToRoute('tech/control')">
                      Sistema de control y análisis de consumos de dispositivos médicos, end to end
                    </button>
                  </div>
                  <div class="col-6">
                    <button mat-flat-button [disableRipple]="true" class="subtitulo" (click)="goToRoute('tech/chain')">
                      Sistema de gestión de la cadena de suministro y optimización de inventarios-RFID
                    </button>
                  </div>
                </div>
                <div class="row sublinks">
                  <div class="col-6">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('tech/management')">

                      Sistema de gestión comercial – S&OP
                    </button>
                  </div>
                  <div class="col-6">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('tech/data')">


                      Sistemas de registros de evidencia del mundo real.
                    </button>
                  </div>
                </div>
                <div class="row sublinks">
                  <div class="col-6">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('tech/rfid')">
                      Dispositivos de RFID
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="somos">
          <button mat-flat-button [disableRipple]="true">
            Estadística e Insights
          </button>
          <div class="sub">
            <div class="row">
              <div class="col-3">
                <h3>Estadística e Insights</h3>
              </div>
              <div class="col-9">
                <div class="row sublinks">
                  <div class="col-4">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('statistics/health')">
                      Estadísticas de salud
                    </button>
                  </div>
                  <div class="col-4">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('statistics/reports')">
                      Reportes de insights
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="somos">
          <button mat-flat-button [disableRipple]="true">
            Ciencia de datos
          </button>
          <div class="sub">
            <div class="row">
              <div class="col-3">
                <h3>Ciencia de datos</h3>
              </div>
              <div class="col-9">
                <div class="row sublinks">
                  <div class="col-4">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('data/models')">
                      Modelos predictivos
                    </button>
                  </div>
                  <div class="col-4">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('data/machinelearning')">
                      Machine learning
                    </button>
                  </div>
                </div>
                <div class="row sublinks">
                  <div class="col-4">
                    <button mat-flat-button [disableRipple]="true" (click)="goToRoute('data/ai')">
                      Inteligencia artificial
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <button mat-flat-button [disableRipple]="true" (click)="goToRoute('contact')">
            Contacto
          </button>
        </li>
        <li>
          <button class="dohealth" mat-flat-button [disableRipple]="true" (click)="goToDohealth()">
            Dohealth
          </button>
        </li>
        <li class="derecha">
          <button (click)="goToLogIn()" mat-flat-button [disableRipple]="true" class="iniciarSesion">
            Iniciar Sesión <mat-icon color="accent">input</mat-icon>
          </button>
        </li>

      </ul>
    </div>

  </div>


  <!---
    <div id="homeNavContainer" style="right: 0%;position: absolute;">
      <ng-container *ngFor="let navRoute of homeUiNavRoutes">

        <div *ngIf="!navRoute.hasChildren && navRoute.navigationDataRoute.path !=='us'&& navRoute.navigationDataRoute.path !=='cookies' && navRoute.navigationDataRoute.path !=='aviso'">
          <button (click)="goToRoute(navRoute.navigationDataRoute.path)" mat-flat-button [disableRipple]="true">
            {{navRoute.navigationDataRoute.name}}
          </button>
        </div>

        <div *ngIf="navRoute.hasChildren && navRoute.navigationDataRoute.path !=='us' && navRoute.navigationDataRoute.path !=='cookies' && navRoute.navigationDataRoute.path !=='aviso'">
          <button mat-flat-button [matMenuTriggerFor]="menu" [disableRipple]="true">
            {{navRoute.navigationDataRoute.name}}
          </button>
          <mat-menu #menu="matMenu">
            <button (click)="goToSubRoute(navRoute.navigationDataRoute.path, child.path)" mat-menu-item
              *ngFor="let child of navRoute.navigationDataRoute.children">
              {{child.name}}
            </button>
          </mat-menu>
        </div>

      </ng-container>


      <ng-container>
        
        <button  (click)="goToLogIn()" mat-flat-button  [disableRipple]="true">
          Iniciar Sesión <mat-icon color="accent">input</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>-->

</mat-toolbar>



<div id="views-container" *ngIf="!isMobile">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!isMobile"></app-footer>